<template>
  <TransitionFade class="related-tags-performance">
    <TagsPerformance
      v-if="shouldShowTagsPerformance"
      title="相關概念股股價表現"
      description="我們列出和公司相關的概念股股價表現，讓你知道公司相較於其他相關公司股價表現如何"
      :tags-performance-list="tagsPerformanceList"
      :is-loading="isLoading"
      :has-loading-error="hasLoadingError"
      :is-signed-in="isSignedIn"
      :click-item-handler="clickItemHandler"
    />
  </TransitionFade>
</template>

<script>
import axios from 'axios'

import TransitionFade from '@/modules/shared/components/TransitionFade.vue'

import { getRelatedTagsAPIUrl } from '../api/tags'

import TagsPerformance from './ContainerTagsPerformance.vue'

export default {
  name: 'RelatedTagsPerformance',
  components: {
    TransitionFade,
    TagsPerformance,
  },
  props: {
    ticker: {
      type: String,
      required: true,
    },
    isSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagsPerformanceList: [],
      isLoading: true,
      hasLoadingError: false,
    }
  },
  computed: {
    shouldShowTagsPerformance() {
      return this.tagsPerformanceList.length > 0 || this.isLoading || this.hasLoadingError
    },
  },
  watch: {
    ticker(newTicker) {
      if (newTicker === undefined || newTicker === '') {
        return
      }
      this.getTagsPerformanceList()
    },
  },
  created() {
    this.$nextTick(() => {
      if (this.ticker === undefined || this.ticker === '') {
        return
      }
      this.getTagsPerformanceList()
    })
  },
  methods: {
    getTagsPerformanceList() {
      this.isLoading = true
      this.hasLoadingError = false
      this.requestRelatedTags(this.ticker)
        .then(({ data }) => {
          this.tagsPerformanceList = data.data.slice(0, 5)
        })
        .catch(() => {
          this.hasLoadingError = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    requestRelatedTags(ticker) {
      const api = getRelatedTagsAPIUrl({
        ticker,
      })
      return axios.get(api)
    },
    clickItemHandler(item) {
      window.amplitudeEvents.clickTag({
        medium: 'analysis_related',
        tagName: item.name,
        tagId: item.url.split('/')[4] || '',
        targetUrl: item.url,
      })
    },
  },
}
</script>
